module.exports = __webpack_public_path__ + "static/media/Gilroy-Black-Italic.6cd43cb0.ttf";